/// <amd-module name="TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

import { IGroupsSettingsAwareState } from "TFS/Admin/Groups/Common/Contracts";

import { settingsPivotReducer } from "TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotReducers";
import { settingsPivotSaga } from "TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotSaga";

export function getSettingsPivotModule(): ISagaModule<IGroupsSettingsAwareState> {
    const reducerMap: ReducersMapObject<IGroupsSettingsAwareState, AnyAction> = {
        settingsState: settingsPivotReducer
    };

    return {
        id: "SettingsPivotState",
        reducerMap,
        sagas: [settingsPivotSaga]
    };
}
